module.exports = __webpack_public_path__ + "static/media/Arcon-01.f92ecce3.svg";